import React from 'react';
import './App.css';
import 'react-virtualized/styles.css';
import 'react-day-picker/dist/style.css';
import './react-day-picker-style-overrides.css';
import { ChakraProvider } from '@chakra-ui/react';
import { ThemeProvider as EmotionThemeProvider } from '@emotion/react';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { AuthProvider } from './hooks';
import { theme } from './theme/theme';
import { designSystem } from './theme/chakra';
import { Root } from './Root';
import { ModalsProvider } from './hooks/useModalsContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { FeatureFlagsProvider } from './hooks/useFeatureFlagsContext';

const queryClient = new QueryClient();

function App() {
  return (
    <ChakraProvider value={designSystem}>
      <EmotionThemeProvider theme={theme}>
        <ModalsProvider>
          <AuthProvider>
            <FeatureFlagsProvider>
              <QueryClientProvider client={queryClient}>
                <ReactQueryDevtools initialIsOpen={false} />
                <Root />
              </QueryClientProvider>
            </FeatureFlagsProvider>
          </AuthProvider>
        </ModalsProvider>
      </EmotionThemeProvider>
    </ChakraProvider>
  );
}

export default App;
